module.exports = __webpack_public_path__ + "media/images/icons/zoom-944e1a80b5f9fce308ae81412a380c8b.svg";